<template>
  <div>
    <iq-card>
      <template #headerTitle>
        <h4 class="card-title text-primary">
          <strong>Maintenance History</strong>
        </h4>
      </template>
      <template #body>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex px-3 align-items-center">
            <!-- <form @submit.prevent="fetchData">
              <b-form-input
                v-model="filters.search"
                placeholder="Search fleet name..."
              />
            </form> -->
            <v-multiselect
              v-model="filters.vehicleTypeIds"
              tag-placeholder="Fleets"
              placeholder="Select Fleets Category"
              label="name"
              track-by="code"
              :options="fleetCategoryOpt"
              :multiple="true"
              :taggable="true"
              class="mr-2"
              style="min-width: 300px"
            />
            <v-multiselect
              v-model="filters.vehicleIds"
              tag-placeholder="Fleets"
              placeholder="Select Fleets"
              label="name"
              track-by="code"
              :options="fleetNameOpt"
              :multiple="true"
              :taggable="true"
              style="min-width: 300px"
            />
            <b-button
              variant="outline-primary"
              class="ml-2 d-flex align-items-center text-nowrap"
              @click="fetchData"
            >
              <i class="fas fa-sliders"></i>
              Filter Data
            </b-button>
          </div>
          <div class="px-3">
            <b-button-group size="sm">
              <b-button
                :variant="viewMode === 'list' ? 'primary' : 'outline-primary'"
                @click="setViewMode('list')"
                title="List View"
              >
                <i class="fa fa-list"></i>
              </b-button>

              <b-button
                :variant="viewMode === 'grid' ? 'primary' : 'outline-primary'"
                @click="setViewMode('grid')"
                title="Card View"
              >
                <i class="fa fa-th-large"></i>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <!-- List/Table View -->
        <div
          v-if="viewMode === 'list'"
          class="table-responsive px-3 pb-4"
          style="font-size: 12px"
        >
          <table class="table align-middle table-striped table-hover">
            <thead class="thead-light">
              <tr>
                <th>Fleet Name</th>
                <th class="text-nowrap">Fleet Type</th>
                <th class="text-nowrap">Company</th>
                <th class="text-center">Total Maintenance</th>
                <th class="text-center">Active</th>
                <th class="text-center">Overdue</th>
                <th class="text-center">Postpone</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(vehicle, index) in paginatedData" :key="index">
                <!-- Fleet Name -->
                <td>
                  <span class="badge badge-success px-2 py-1">
                    {{ vehicle.name }}
                  </span>
                </td>

                <!-- Fleet Type -->
                <td>{{ vehicle.vehicle_type?.name }}</td>

                <!-- Company -->
                <td>{{ vehicle?.company?.company ?? '-' }}</td>

                <!-- Total Maintenance -->
                <td class="text-center">{{ vehicle.total_maintenance }}</td>

                <!-- On Time -->
                <td class="text-center">{{ vehicle.active }}</td>

                <!-- Overdue -->
                <td class="text-center">{{ vehicle.overdue }}</td>

                <!-- Postpone -->
                <td class="text-center">{{ vehicle.postpone }}</td>

                <!-- Action -->
                <td class="text-center">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="handleDetail(vehicle.id)"
                  >
                    Detail
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Grid/Card View -->
        <div v-else class="px-3 pb-4">
          <div class="row">
            <div
              class="col-md-4 mb-4"
              v-for="(vehicle, idx) in paginatedData"
              :key="`card-${idx}`"
            >
              <div class="card shadow-sm h-100">
                <div class="p-3">
                  <div class="card-image-placeholder"></div>
                </div>
                <div class="card-body pt-0">
                  <h5 class="card-title text-primary font-weight-bold mb-1">
                    {{ vehicle.name }}
                    <span class="ml-2 text-danger">●</span>
                  </h5>
                  <div class="text-muted small mb-2">
                    {{ vehicle.vehicle_type?.name }} •
                    {{ vehicle?.company?.company ?? '-' }} • Owned
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between bg-light p-2 mb-3"
                    style="border-radius: 8px"
                  >
                    <div class="text-muted d-flex align-items-center">
                      <i class="fa fa-info-circle mr-2 text-primary"></i>
                      Total Plan Maintenance
                    </div>
                    <div class="font-weight-bold text-black">
                      {{ vehicle.total_maintenance }} Maintenance
                    </div>
                  </div>
                  <b-button
                    block
                    variant="primary"
                    @click="handleDetail(vehicle.id)"
                  >
                    <i class="fa fa-clipboard-list mr-2"></i>
                    Detail Maintenance
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mt-4 d-flex align-items-center w-100 justify-content-between px-3 pb-2"
        >
          <div>
            <span class="mb-0">
              Total Rows :
              <strong>{{ totalRows }}</strong>
            </span>
          </div>
          <div class="d-flex align-items-center">
            <b-pagination
              class="mb-0 mr-3"
              v-model="filters.page"
              :total-rows="totalRows"
              :per-page="filters.limit"
              first-number
              align="center"
            ></b-pagination>
            <b-form-select
              plain
              v-model="filters.limit"
              :options="limitOptions"
              style="width: 140px"
              @input="onChangeLimit"
            ></b-form-select>
          </div>
        </div>
      </template>
    </iq-card>
  </div>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import FilterMaintenanceFormNew from '../FilterMaintenanceFormNew.vue'
import PlanMaintenanceSummary from '../PlanMaintenanceSummary.vue'
import { fleetOptions, limitOptions } from '@/src/core/mock/data/optionsData'
import { fleetsActions, pmsActions } from '@/src/Utils/helper'

export default {
  name: 'MaintenanceHistoryNew',
  components: {
    PlanMaintenanceSummary,
    FilterMaintenanceFormNew,
  },
  data() {
    return {
      limitOptions,
      showModalFilter: false,
      viewMode: 'list',
      selectedFleetType: '',
      maintenanceData: [],
      maintenanceChecked: [],
      filters: {
        action: '',
        search: '',
        dateRange: [
          new Date(moment().startOf('year')),
          new Date(moment().endOf('year')),
        ],
        limit: 10,
        page: 1,
        total: 0,
        vehicleIds: [],
        vehicleTypeIds: [],
      },
      fleetCategoryOpt: [],
      fleetNameOpt: [],
    }
  },
  computed: {
    fleetTypeOptions() {
      const unique = Array.from(
        new Set(this.maintenanceData.map((d) => d.fleetType))
      ).filter(Boolean)
      return unique.map((t) => ({ text: t, value: t }))
    },
    filteredData() {
      let data = [...this.maintenanceData]
      if (this.selectedFleetType) {
        data = data.filter((d) => d.fleetType === this.selectedFleetType)
      }
      if (this.filters.search && this.filters.search.trim() !== '') {
        const s = this.filters.search.trim().toLowerCase()
        data = data.filter(
          (d) =>
            d.name?.toLowerCase().includes(s) ||
            d.company?.toLowerCase().includes(s)
        )
      }
      return data
    },
    totalRows() {
      return this.filteredData.length
    },
    paginatedData() {
      const start = (this.filters.page - 1) * this.filters.limit
      return this.filteredData.slice(start, start + this.filters.limit)
    },
  },
  methods: {
    ...pmsActions,
    ...fleetsActions,
    resetFilter() {
      // Reset semua filter ke nilai default
      this.filters = {
        action: '',
        search: '',
        status: null,
        method: null,
        dateRange: [
          new Date(moment().startOf('year')),
          new Date(moment().endOf('year')),
        ],
        limit: 10,
        page: 1,
        total: 0,
        vehicleIds: [],
        vehicleTypeIds: [],
      }

      // Reset selected fleet type
      this.selectedFleetType = ''

      // Apply filter setelah reset
      this.fetchData()
    },
    setViewMode(mode) {
      this.viewMode = mode
    },
    onChangeLimit() {
      this.filters.page = 1
    },
    toggleSelectAll(checked) {
      const currentPageIds = this.maintenanceData.map((item) => item.id)
      if (checked) {
        const unique = new Set([...this.maintenanceChecked, ...currentPageIds])
        this.maintenanceChecked = Array.from(unique)
      } else {
        this.maintenanceChecked = this.maintenanceChecked.filter(
          (id) => !currentPageIds.includes(id)
        )
      }
    },
    handleDetail(id) {
      this.$router.push({
        path: 'maintenance-fleet-detail',
        query: { fleet_id: id },
      })
    },

    buildPayload() {
      const mappingIds = (data) => {
        return data?.map((el) => el.code)?.toString()
      }
      const payload = {
        action: this.filters.action,
        search: this.filters.search,
        start_date: this.filters.dateRange
          ? moment(this.filters.dateRange[0]).format('YYYY-MM-DD')
          : null,
        end_date: this.filters.dateRange
          ? moment(this.filters.dateRange[1]).format('YYYY-MM-DD')
          : null,
        limit: this.filters.limit,
        page: this.filters.page,
        vehicle_id: mappingIds(this.filters.vehicleIds),
        vehicle_type_id: mappingIds(this.filters.vehicleTypeIds),
      }
      return payload
    },

    async fetchData() {
      // Fetch maintenance data based on filters
      try {
        const res = await this.getPmsSummaryVehicles(this.buildPayload())

        if (res?.status === 'success') {
          this.maintenanceData = res.data.data
        }
      } catch (error) {
        console.log('Error fetching maintenance data:', error)
      }
    },

    async fetchFleetCategories() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.fleetCategoryOpt = []
        const res = await this.getFleetTypes(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetCategoryOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFleets() {
      let params = {
        page: 1,
        perPage: 1000,
        active: true,
      }
      try {
        this.fleetNameOpt = []
        const res = await this.getFleets(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetNameOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {
    this.fetchData()
    this.fetchFleetCategories()
    this.fetchFleets()
  },
}
</script>
<style scoped>
table td {
  line-height: 16px !important;
}
.card-image-placeholder {
  width: 100%;
  height: 180px;
  background: #e9edf4;
  border-radius: 12px;
}
</style>
